<template>
  <div class="agreement">
    <header class="header">
      <span> {{ agreement.popupTitle }} </span>
      <div @click="cancelPopup">
        <img src="~@/assets/images/cancel_1.jpeg" alt="" class="cancel" style="width: 0.64rem; height: auto" />
      </div>
    </header>

    <div class="bodyAgreement" v-html="agreement.popupContent">
      <!-- <h3 class="title">{{agreement.popupTitle}}</h3> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: 'XXX',
    },
    agreement: {},
  },
  data() {
    return {}
  },

  methods: {
    cancelPopup() {
      this.$emit('cancelPopup', false)
    },
  },
  mounted() {},
}
</script>
<style lang="scss" scoped>
.agreement {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    height: 62px;
    // width: calc(100% - 30px);
    background: #f9f9f9;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #333333;
      letter-spacing: 1.14px;
    }
  }
  .bodyAgreement {
    padding: 10px;
    font-size: 14px;
    .title {
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.bodyAgreement {
  ul{list-style: auto;}
  li::marker {
    unicode-bidi: isolate;
    font-variant-numeric: tabular-nums;
    text-transform: none;
    text-indent: 0px !important;
    text-align: start !important;
    text-align-last: start !important;
  }
}
</style>
